import { render, staticRenderFns } from "./ProjectItems.vue?vue&type=template&id=5c907e0f&scoped=true"
import script from "./ProjectItems.vue?vue&type=script&lang=js"
export * from "./ProjectItems.vue?vue&type=script&lang=js"
import style0 from "./ProjectItems.vue?vue&type=style&index=0&id=5c907e0f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c907e0f",
  null
  
)

export default component.exports